import React from 'react';
import PropTypes from 'prop-types';

// Components
import { ErrorPage } from '../../../Family/components/ErrorPage';
import { FamilyChildSkeleton } from '../familyChildSkeleton';

// Constants
import { REQUEST_STATUSES } from '../../constants';

const SkeletonChildWrapper = ({ status, children }) => {
  if (status === REQUEST_STATUSES.loading) {
    return <FamilyChildSkeleton />;
  }

  if (status === REQUEST_STATUSES.error) {
    return <ErrorPage />;
  }

  return <>{children}</>;
};

SkeletonChildWrapper.propTypes = {
  status: PropTypes.string,
};

export { SkeletonChildWrapper };
